export default __webpack_public_path__ + "static/media/call.ff00f913.gif";